<template>
  <div class="integralList seller-style">
    <h2 class="f18 fb normal gray_2">积分管理</h2>
    <div>
      <div class="box20"></div>
      <p class="f16 pad10_l">基础设置</p>
      <div class="box20"></div>
      <el-table :data="pointsRuleList" style="width: 100%">
        <el-table-column prop="name" label="规则名称" width="300"> </el-table-column>
        <el-table-column prop="detail" label="规则详情" width="300">
          <template slot-scope="scope">
            <p v-html="scope.row.detail"></p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <p class="blue cursor" @click="setIntegral(scope.row)">设置</p>
          </template>
        </el-table-column>
      </el-table>
      <div class="box30"></div>
      <p class="f16 pad10_l">发放规则设置</p>
      <div class="box10"></div>
      <el-button type="primary" class="mar10_l" @click="handleEdit('', 1)">新建规则</el-button>
      <div class="box10"></div>
      <el-table :data="grantRuleDtlList" style="width: 100%">
        <el-table-column prop="condition" label="发放规则" width="300"> </el-table-column>
        <el-table-column prop="detail" label="发放数量" width="100"> </el-table-column>
        <el-table-column prop="applyCustomer" label="适用客户" width="100"> </el-table-column>
        <el-table-column prop="lastUpdateDate" width="200" label="更新时间"> </el-table-column>
        <el-table-column width="200" label="状态">
          <template slot-scope="scope">
            <el-switch
              @change="validRuleDtl(scope.row)"
              v-model="scope.row.status"
              active-color="#1890ff"
              inactive-color="#cccccc"
              :disabled="scope.row.busType === 5"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="blue cursor" @click="handleEdit(scope.row.id, 1)">查看</span>
            <span class="blue pad5_lr">|</span>
            <span class="blue cursor" @click="deletedRuleDtl(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="box30"></div>
      <p class="f16 pad10_l">使用规则设置</p>
      <div class="box10"></div>
      <el-button type="primary" class="mar10_l" @click="handleEdit('', 2)">新建规则</el-button>
      <div class="box10"></div>
      <el-table :data="consumeRuleDtlList" style="width: 100%">
        <el-table-column prop="condition" label="使用条件" width="300"> </el-table-column>
        <el-table-column prop="detail" label="使用数量" width="200"> </el-table-column>
        <el-table-column prop="lastUpdateDate" width="200" label="更新时间"> </el-table-column>
        <el-table-column width="200" label="状态">
          <template slot-scope="scope">
            <el-switch @change="validRuleDtl(scope.row)" v-model="scope.row.status" active-color="#1890ff" inactive-color="#cccccc"> </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="blue cursor" @click="handleEdit(scope.row.id, 2)">查看</span>
            <span class="blue pad5_lr">|</span>
            <span class="blue cursor" @click="deletedRuleDtl(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="积分发放" :visible.sync="ruleCheckVisible" width="700px">
      <div>
        <div class="mar20_b">
          <span>适用人群：</span>
          <span v-if="ruleDtl.applyCustomerType === 1">全部人群</span>
          <span v-if="ruleDtl.applyCustomerType === 2">客户分组</span>
          <span v-if="ruleDtl.applyCustomerType === 3">指定客户</span>
        </div>
        <div class="mar20_b">
          <span>规则详情：</span>
          <span v-if="ruleDtl.busType === 1">
            根据订单发放，
            <template v-if="ruleDtl.ruleType === 2">订单每满{{ ruleDtl.ruleKey2 }}元，发放{{ ruleDtl.ruleValue2 }}{{ ruleDtl.name }}</template>
            <template v-if="ruleDtl.ruleType === 3">每笔订单发放订单金额的{{ ruleDtl.ruleValue3 }}%</template>
            。
          </span>
          <span v-if="ruleDtl.busType === 4">根据评论发放，每个好评评论字数达到{{ ruleDtl.ruleKey4 }}字，发放{{ ruleDtl.name }}。</span>
          <span v-if="ruleDtl.busType === 2"
            >根据商品发放，
            <template v-if="ruleDtl.goodRuleType === 1"
              >每种商品成功交易{{ ruleDtl.goodRuleKey1 }}件，发放{{ ruleDtl.goodRuleValue1 }}{{ ruleDtl.name }}</template
            >
            <template v-if="ruleDtl.goodRuleType === 2"
              >每种商品每成功交易{{ ruleDtl.goodRuleKey2 }}元，发放{{ ruleDtl.goodRuleValue2 }}{{ ruleDtl.name }}</template
            >
            <template v-if="ruleDtl.goodRuleType === 3">每件商品，发放订单中该商品金额的{{ ruleDtl.goodRuleValue3 }}%</template>
            。
          </span>
          <span v-if="ruleDtl.busType === 5">
            累计发放，
            <template v-if="ruleDtl.sbusType === 1"> 按消费金额发放 </template>
            <template v-if="ruleDtl.sbusType === 2"> 按商品发放 </template>
            。
          </span>
        </div>
        <div v-if="ruleDtl.goodType">
          <span>适用货品：</span>
          <span v-if="ruleDtl.goodType === 1">全部商品</span>
          <span v-if="ruleDtl.goodType === 2">指定商品</span>
        </div>
        <div class="box50"></div>
      </div>
    </el-dialog>
    <el-dialog :title="setName" :visible.sync="popVisible" width="550px">
      <div v-if="setting === 'expiryType'" class="discountingPop">
        <el-radio-group v-model="pointsRule.expiryType">
          <el-radio :label="1">永久有效</el-radio>
          <el-radio :label="2">
            <span class="pad10_r">从获得开始至</span>
            <el-date-picker
              :disabled="pointsRule.expiryType !== 2"
              v-model="pointsRule.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59"
              :picker-options="pickerOptions"
              popper-class="seller-style"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-radio>
          <el-radio :label="3" class="commonValidity">
            <span class="pad10_r">每笔有效期为</span>
            <el-input
              popper-class="seller-style"
              v-model="pointsRule.expiryRuleKey"
              @input="pointsRule.expiryRuleKey = formatNums(pointsRule.expiryRuleKey, false)"
              :disabled="pointsRule.expiryType !== 3"
            ></el-input>
            <el-select popper-class="seller-style" v-model="pointsRule.expiryRuleValue" placeholder="请选择">
              <el-option :disabled="pointsRule.expiryType !== 3" v-for="item in commonSelectList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-radio>
          <p class="f12 gray9 lin_20">“年”支持 1-3 年，“月”支持 1-18 个月，“日”支持 1-365 日。</p>
          <p class="f12 gray9 lin_20">示例：若设置为1年，则用户在获取后1年后失效</p>
        </el-radio-group>
      </div>
      <div v-if="setting === 'name'">
        <span>将名称自定义为</span>
        <el-input v-model="pointsRule.name" maxlength="5" placeholder="如：金币。最多5个字"></el-input>
      </div>
      <div class="discountingPop" v-if="setting === 'deductionRatio'">
        <el-input v-model="pointsRule.deductionRatio" @input="pointsRule.deductionRatio = formatNums(pointsRule.deductionRatio, true)"></el-input>
        <span>可抵用现金1元</span>
      </div>
      <div class="discountingPop" v-if="setting === 'grantType'">
        <el-radio-group v-model="pointsRule.grantType">
          <el-radio :label="1">支付完成立即发放</el-radio>
          <el-radio :label="2">确认收货后立即发放</el-radio>
          <!--          <el-radio :label="3">
            <span>确认收货后</span>
            <el-input v-model="pointsRule.grantValue"
            @input="pointsRule.grantValue=formatNums(pointsRule.grantValue,false)"
             :disabled="pointsRule.grantType !== 3"></el-input>
            <span>天</span>
          </el-radio>-->
        </el-radio-group>
        <p class="f12">积分发放后，订单售后退款不退还积分</p>
      </div>
      <div v-if="setting === 'grantLimit'">
        <span>每个客户每天通过消费最多获取</span>
        <el-input v-model="pointsRule.grantLimit"></el-input>
        <span></span>
        <p class="f12">仅针对每购买金额X元、每成功交易X笔赠送的有效</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRule()">取 消</el-button>
        <el-button type="primary" @click="saveRule()" :disabled="isSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      setting: "", // 当前点击的设置的弹框标识
      setName: "", // 当前点击的设置的弹框title
      pointsRuleList: [], // 通用设置表格
      pointsRule: {
        id: "",
        shopId: this.shopId,
        name: "",
        expiryType: 1,
        expiryRule: "",
        expiryRuleKey: "",
        expiryRuleValue: "y",
        startTime: "",
        endTime: "",
        deductionRatio: 0,
        grantLimit: 0,
        consumeLimit: 0,
        grantType: 1,
        grantValue: "",
      }, // 规则
      rawPointsRule: {},
      grantRuleDtlList: [],
      consumeRuleDtlList: [],
      popVisible: false, // 设置弹框是否展示
      commonSelectList: [
        {
          value: "y",
          label: "年",
        },
        {
          value: "m",
          label: "月",
        },
        {
          value: "d",
          label: "日",
        },
      ],
      grantLimitChecked: false,
      customizationChecked: false,
      discountingChecked: false,
      shopId: "",
      isSubmit: false,
      // 禁用选择当前时间之前
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      ruleCheckVisible: false,

      ruleDtl: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getShopDefault();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    getPointsRuleDtl(id) {
      const params = { id, shopId: this.shopId };
      this.$store.dispatch("points/points/getPointsRuleDtl", this.$qs.stringify(params)).then((data) => {
        this.ruleCheckVisible = true;
        const ruleDtl = {
          id: data.id,
          ruleId: data.ruleId,
          pointsType: data.pointsType,
          busType: data.busType,
          timeStr: [data.startTime, data.endTime],
          applyCustomerType: data.applyCustomerType,
          applyCustomerAttr: eval(data.applyCustomerAttr),
          sbusType: data.sbusType,
          subRuleAttrVal: eval(data.subRuleAttr),
        };
        // 1订单 2商品 4评论
        if (data.busType === 1) {
          ruleDtl.ruleType = data.ruleType;
          ruleDtl[`ruleKey${data.ruleType}`] = data.ruleKey;
          ruleDtl[`ruleValue${data.ruleType}`] = data.ruleValue;
        }
        if (data.busType === 4) {
          ruleDtl.ruleType = data.ruleType;
          ruleDtl[`ruleKey4`] = data.ruleKey;
          ruleDtl[`ruleValue4`] = data.ruleValue;
        }
        if (data.busType === 2 || data.busType === 5) {
          ruleDtl.goodRuleType = data.ruleType;
          ruleDtl[`goodRuleKey${data.ruleType}`] = data.ruleKey;
          ruleDtl[`goodRuleValue${data.ruleType}`] = data.ruleValue;
          ruleDtl.goodType = 1;
          if (data.busId && JSON.parse(data.busId).length > 0) {
            ruleDtl.goodType = 2;
          }
        }
        this.ruleDtl = ruleDtl;
        this.$set(this.ruleDtl, "name", this.pointsRule.name);
      });
    },

    handleEdit(id, pointsType) {
      if (!this.rawPointsRule.id) {
        this.$message.error("请先基础设置");
        return;
      }
      const url = id
        ? `/mj/integralEdit?id=${id}&shopId=${this.shopId}&ruleId=${this.rawPointsRule.id}&pointsType=${pointsType}&name=${this.pointsRule.name}` // eslint-disable-line
        : `/mj/integralEdit?shopId=${this.shopId}&ruleId=${this.rawPointsRule.id}&pointsType=${pointsType}&name=${this.pointsRule.name}`; // eslint-disable-line
      this.$router.push(url);
    },
    setIntegral(row) {
      this.setting = row.setting;
      this.setName = row.name;
      if (this.setting === "rule") {
        const url = `/mj/integral/ruleShow?shopId=${this.shopId}&ruleId=${this.rawPointsRule.id}`;
        this.$router.push(url);
        return;
      }

      // this.initRule();
      this.grantLimitChecked = false;
      this.customizationChecked = false;
      this.discountingChecked = false;
      if (this.pointsRule.grantLimit) {
        this.grantLimitChecked = true;
      }
      if (this.pointsRule.name) {
        this.customizationChecked = true;
      }
      if (this.pointsRule.deductionRatio) {
        this.discountingChecked = true;
      }
      this.popVisible = true;
    },
    cancelRule() {
      this.popVisible = false;
    },
    saveRule() {
      const pointsRule = Object.assign({}, this.pointsRule);
      // 校验参数
      if (this.setting === "expiryType") {
        if (pointsRule.expiryType === 2 && !pointsRule.endTime) {
          this.$message.error("请选择时间");
          return;
        }
        if (pointsRule.expiryType === 3) {
          if (!pointsRule.expiryRuleKey) {
            this.$message.error("请输入有效期");
            return;
          }
          const number = parseFloat(pointsRule.expiryRuleKey);
          if (pointsRule.expiryRuleValue === "y" && number > 3) {
            this.$message.error("支持 1-3 年");
            return;
          }
          if (pointsRule.expiryRuleValue === "m" && number > 18) {
            this.$message.error("支持 1-18 个月");
            return;
          }
          if (pointsRule.expiryRuleValue === "d" && number > 365) {
            this.$message.error("支持 1-365 日");
            return;
          }
        }
      }
      if (this.setting === "name") {
        if (!pointsRule.name) {
          this.$message.error("请输入名称");
          return;
        }
      }
      if (this.setting === "grantLimit") {
        if (!pointsRule.grantLimit) {
          pointsRule.grantLimit = 0;
        }
      }
      if (this.setting === "deductionRatio") {
        if (!pointsRule.deductionRatio || pointsRule.deductionRatio < 0) {
          pointsRule.deductionRatio = 0;
        }
      }
      if (this.setting === "grantType") {
        if (pointsRule.grantType === 3 && !pointsRule.grantValue) {
          this.$message.error("请输入确认收货天数");
          return;
        }
      }
      this.isSubmit = true;
      // 处理参数
      if (pointsRule.expiryType === 1) {
        pointsRule.endTime = "";
        pointsRule.expiryRule = "";
      }
      if (pointsRule.expiryType === 2 && pointsRule.endTime) {
        pointsRule.expiryRule = "";
      }
      if (pointsRule.expiryType === 3 && pointsRule.expiryRuleKey) {
        pointsRule.endTime = "";
        pointsRule.expiryRule = pointsRule.expiryRuleKey + pointsRule.expiryRuleValue;
      }
      if (pointsRule.grantType === 1 || pointsRule.grantType === 2) {
        pointsRule.grantValue = "0";
      }
      if (pointsRule.grantType === 3) {
        pointsRule.grantType = 2;
      }
      this.$store.dispatch("points/points/addOrModifyRule", pointsRule).then((data) => {
        this.isSubmit = false;
        if (data.code !== "0") {
          this.$message.error(data.msg);
          return;
        }
        this.popVisible = false;
        this.getPointsRule();
      });
    },
    getShopDefault() {
      this.$store.dispatch("header/getShopDefault", {}).then((data) => {
        if (data && data.shopIdStr) {
          this.shopId = data.shopIdStr;
          this.getPointsRule();
        }
      });
    },
    getPointsRule() {
      this.$store.dispatch("points/points/getPointsRule", this.$qs.stringify({ shopId: this.shopId })).then((data) => {
        this.rawPointsRule = data || {};
        this.grantRuleDtlList = this.rawPointsRule.grantRuleDtlList || [];
        this.consumeRuleDtlList = this.rawPointsRule.consumeRuleDtlList || [];
        this.grantRuleDtlList.forEach((dtl) => {
          this.initRuleDtl(dtl);
        });
        this.consumeRuleDtlList.forEach((dtl) => {
          this.initRuleDtl(dtl);
        });
        this.initRule();
        if (!this.rawPointsRule || !this.rawPointsRule.id) {
          this.saveInitRule();
        }
      });
    },
    saveInitRule() {
      const pointsRule = Object.assign({}, this.pointsRule);
      // 处理参数
      if (pointsRule.expiryType === 1) {
        pointsRule.endTime = "";
        pointsRule.expiryRule = "";
      }
      if (pointsRule.expiryType === 2 && pointsRule.endTime) {
        pointsRule.expiryRule = "";
      }
      if (pointsRule.expiryType === 3 && pointsRule.expiryRuleKey) {
        pointsRule.endTime = "";
        pointsRule.expiryRule = pointsRule.expiryRuleKey + pointsRule.expiryRuleValue;
      }
      if (pointsRule.grantType === 1 || pointsRule.grantType === 2) {
        pointsRule.grantValue = "0";
      }
      if (pointsRule.grantType === 3) {
        pointsRule.grantType = 2;
      }
      this.$store.dispatch("points/points/addOrModifyRule", pointsRule).then((data) => {
        if (data.code !== "0") {
          this.$message.error(data.msg);
          return;
        }
        this.getPointsRule();
      });
    },
    initRuleDtl(dtl) {
      let condition = "";
      let applyCustomer = "";
      let detail = dtl.ruleValue;
      if (dtl.applyCustomerType === 1) {
        applyCustomer = "所有人群";
      } else if (dtl.applyCustomerType === 2) {
        applyCustomer = "指定分组";
      } else if (dtl.applyCustomerType === 3) {
        applyCustomer = "指定客户";
      }
      if (dtl.busType === 1) {
        if (dtl.ruleType === 1) {
          condition = "";
        }
        if (dtl.ruleType === 2) {
          condition = `每笔订单成功交易${dtl.ruleKey}元`;
        }
        if (dtl.ruleType === 3) {
          condition = "每笔订单交易金额";
          detail = `${detail}%`;
        }
      }
      if (dtl.busType === 2) {
        if (dtl.ruleType === 1) {
          condition = `单件商品成功交易${dtl.ruleKey}件`;
        }
        if (dtl.ruleType === 2) {
          condition = `单件商品每成功交易${dtl.ruleKey}元`;
        }
        if (dtl.ruleType === 3) {
          condition = "单件商品交易金额";
          detail = `${detail}%`;
        }
      }
      if (dtl.busType === 4) {
        condition = `每个商品好评评论字数达到${dtl.ruleKey}字`;
        detail = `${detail}`;
      }
      if (dtl.busType === 5) {
        const subRuleAttr = eval(dtl.subRuleAttr);
        if (dtl.sbusType === 1) {
          condition = `累计消费满${subRuleAttr[0].ruleKey}元`;
          detail = `${subRuleAttr[0].ruleValue}`;
        }
        if (dtl.sbusType === 2) {
          condition = `累计消费满${subRuleAttr[0].ruleKey}件`;
          detail = `${subRuleAttr[0].ruleValue}`;
        }
      }
      if (dtl.busType === 6) {
        condition = `社区激励`;
        detail = `${detail}`;
      }
      this.$set(dtl, "condition", condition);
      this.$set(dtl, "detail", detail);
      this.$set(dtl, "applyCustomer", applyCustomer);
      this.$set(dtl, "status", dtl.isValid === 1);
    },
    initRule() {
      const rule = this.rawPointsRule;
      let expiryTypeName = "";
      if (rule.expiryType === 1) {
        expiryTypeName = "永久有效";
      } else if (rule.expiryType === 2) {
        expiryTypeName = `截止日期${rule.endTime}`;
      } else if (rule.expiryType === 3) {
        const find = this.commonSelectList.find((x) => rule.expiryRule.indexOf(x.value) !== -1);
        const expiryRuleKey = rule.expiryRule.substring(0, rule.expiryRule.length - 1);
        expiryTypeName = `有效期为${expiryRuleKey}${find.label}`;
      }
      let grantTypeName = "";
      if (rule.grantType === 1) {
        grantTypeName = "支付完成立即发放";
      } else if (rule.grantType === 2) {
        grantTypeName = "确认收货后立即发放";
      }
      this.pointsRuleList = [
        {
          name: "有效期",
          detail: expiryTypeName,
          setting: "expiryType",
        },
        {
          name: "名称自定义",
          detail: rule.name ? rule.name : "积分",
          setting: "name",
        },
        {
          name: "支付抵现",
          detail: rule.deductionRatio ? `${rule.deductionRatio}可抵用现金1元` : "未抵扣",
          setting: "deductionRatio",
        },
        {
          name: "获取方式",
          detail: grantTypeName,
          setting: "grantType",
        },
        {
          name: "用户单日获取上限",
          detail: rule.grantLimit ? rule.grantLimit : "无上限",
          setting: "grantLimit",
        },
        {
          name: "规则展示",
          detail: "",
          setting: "rule",
        },
      ];
      this.pointsRule = {
        id: rule.id ? rule.id : "",
        shopId: rule.shopId ? rule.shopId : this.shopId,
        name: rule.name ? rule.name : "",
        expiryType: rule.expiryType ? rule.expiryType : 1,
        expiryRule: rule.expiryRule ? rule.expiryRule : "",
        expiryRuleKey: rule.expiryRule ? rule.expiryRule.substring(0, rule.expiryRule.length - 1) : "",
        expiryRuleValue: rule.expiryRule ? rule.expiryRule.substring(rule.expiryRule.length - 1) : "y",
        startTime: rule.startTime ? rule.startTime : "",
        endTime: rule.expiryType === 2 && rule.endTime ? rule.endTime : "",
        deductionRatio: rule.deductionRatio ? rule.deductionRatio : "",
        grantLimit: rule.grantLimit ? rule.grantLimit : "",
        consumeLimit: rule.consumeLimit ? rule.consumeLimit : "",
        grantType: rule.grantType && rule.grantValue ? 3 : rule.grantType,
        grantValue: rule.grantValue ? rule.grantValue : "",
        rule: rule.rule ? rule.rule : "",
      };
    },
    deletedRuleDtl(id) {
      const params = { id, isDel: 1 };
      this.updateRuleDtl(params);
    },
    validRuleDtl(row) {
      const params = { id: row.id, isValid: row.status ? 1 : 0 };
      this.updateRuleDtl(params);
    },
    updateRuleDtl(params) {
      this.$store.dispatch("points/points/addOrModifyRuleDtl", params).then(() => {
        this.getPointsRule();
      });
    },
    // num 输入的数字 decimal 小数 true false
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      return value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
